import { MessageCircle, Phone } from "lucide-react";
import { motion } from "framer-motion";
import { WA, PHONE } from "@/content";

export default function WhatsAppFloat() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-center gap-3" data-testid="floating-actions">
      <motion.a
        href={PHONE.tel}
        data-testid="floating-call-button"
        aria-label={`Llamar al ${PHONE.intl}`}
        title={`Llamar al ${PHONE.intl}`}
        initial={{ opacity: 0, scale: 0, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 2.25, duration: 0.5, type: "spring", bounce: 0.45 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-ink text-white shadow-[0_14px_30px_-10px_rgba(15,23,42,0.6)] hover:bg-brand-orange transition-colors duration-300"
      >
        <Phone className="h-5 w-5" />
      </motion.a>
      <motion.a
        href={WA.info}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Escríbenos por WhatsApp"
        initial={{ opacity: 0, scale: 0, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 2, duration: 0.5, type: "spring", bounce: 0.45 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_16px_35px_-10px_rgba(37,211,102,0.7)] wa-pulse"
      >
        <MessageCircle className="h-6 w-6" />
      </motion.a>
    </div>
  );
}
